<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-8>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="pa-2 rounded-lg">
              <v-card-title primary-title class="pa-2">
                {{ $t("Profile.userData") }}
                <v-spacer></v-spacer>
                <v-btn
                  color="#077893"
                  rounded
                  dark
                  small
                  @click="Fn_SyncOneID"
                  :loading="LoadingSync"
                >
                  <v-icon class="mr-1">mdi-refresh-circle</v-icon>
                  {{ $t("Profile.SyncOneID") }}
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12 lg3 pa-1>
                    <center>
                      <v-img
                        width="90"
                        v-if="_TiTleName === 'นาย'"
                        :src="require('@/assets/img/profileMan.png')"
                      ></v-img>
                      <v-img
                        width="90"
                        v-else
                        :src="require('@/assets/img/profileWoman.png')"
                      ></v-img>
                    </center>
                  </v-flex>
                  <v-flex xs12 lg4 pa-1>
                    <h2>{{ _BusinessNameTH }}</h2>
                    <span style="font-size: 16px">{{ _BusinessNameEng }}</span>
                    <p class="blue--text pt-1">
                      <v-icon class="mb-1 mr-1" color="blue"
                        >mdi-account-star-outline</v-icon
                      >
                      {{ $t("Profile.namesurname") }}
                    </p>
                  </v-flex>
                  <v-divider
                    vertical
                    v-if="$vuetify.breakpoint.lgAndUp"
                  ></v-divider>
                  <v-flex xs12 lg5 pa-1>
                    <v-layout row wrap pa-0 pl-7>
                      <v-flex xs12 lg5>
                        <b> {{ $t("Profile.username") }} : </b>
                      </v-flex>
                      <v-flex xs12 lg7>
                        {{ _Username }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap pa-0 pl-7>
                      <v-flex xs12 lg5>
                        <b>{{ $t("Profile.accountId") }} :</b>
                      </v-flex>
                      <v-flex xs12 lg7>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              color="#077893"
                              style="cursor: pointer"
                              small
                              @click="Fn_CopyDetail(_AccountId)"
                              v-on="on"
                              >mdi-file-multiple-outline</v-icon
                            >
                          </template>
                          <span>{{ $t("consentlist.copy") }}</span>
                        </v-tooltip>
                        {{ _AccountId }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap pa-0 pl-7>
                      <v-flex xs12 lg5>
                        <b>{{ $t("Profile.email") }} :</b>
                      </v-flex>
                      <v-flex xs12 lg7>
                        <!-- <v-btn
                          color="#077893"
                          x-small
                          icon
                          @click="Fn_EditEmail()"
                        >
                          <v-icon> mdi-pencil</v-icon>
                        </v-btn> -->
                        {{ _Email }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap pa-0 pl-7>
                      <v-flex xs12 lg5>
                        <b>{{ $t("Profile.Phone") }} :</b>
                      </v-flex>
                      <v-flex xs12 lg7>
                        <!-- <v-btn
                          color="#077893"
                          x-small
                          icon
                          @click="Fn_EditPhone()"
                        >
                          <v-icon> mdi-pencil</v-icon>
                        </v-btn> -->
                        {{ _Phone }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          justify-center
          align-center
          pt-7
          pb-7
          v-if="_SelectAccountId.length > 1 && _SelectAccountId != '00000'"
        >
          <v-flex xs11 lg11>
            <v-card class="pa-2 rounded-lg">
              <v-card-title primary-title class="pa-2">
                {{ $t("Profile.company") }}
                <!-- <h4>{{ _SelectBusinessNameEng }}</h4> -->
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap justify-start align-center>
                  <v-flex xs12 lg3 pa-1>
                    <center>
                      <v-overlay :value="loadingDownloadData">
                        <div class="text-center">{{ $t("overlay.load") }}</div>
                        <v-progress-circular
                          :value="loadingDownloadData"
                          indeterminate
                          size="70"
                          class="ml-9 mt-3"
                        >
                        </v-progress-circular>
                      </v-overlay>
                      <v-avatar size="100" v-if="ImageData.length > 0">
                        <v-img
                          style="background-size: contain !important"
                          :src="'data:' + FileType + ';base64,' + ImageData"
                        ></v-img>
                      </v-avatar>
                      <v-avatar v-else size="100" color="#077893" class="mr-2">
                        <v-icon size="80" color="white"
                          >mdi-account-settings-outline</v-icon
                        >
                      </v-avatar>
                    </center>
                    <!-- <v-layout row wrap justify-end align-end mt-n8 mr-3>
                      <v-flex xs12 lg2>
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ml-3"
                              color="#077893"
                              v-on="on"
                              v-bind="attrs"
                              x-small
                              fab
                              dark
                            >
                              <v-icon @click="Fn_UploadFile">mdi-camera</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("consentlist.pic") }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout> -->
                  </v-flex>
                  <v-flex xs12 sm12 lg4 md4 pa-1>
                    <h2 class="pb-1">{{ _SelectBusinessNameEng }}</h2>
                    <span style="font-size: 16px">{{
                      _SelectBusinessNameTH
                    }}</span>
                    <br />
                    <div class="blue--text pt-1">
                      <v-icon class="mb-1 mr-1" color="blue">mdi-domain</v-icon>
                      <span>{{ $t("Profile.companyname") }}</span>
                    </div>
                  </v-flex>
                  <v-divider
                    vertical
                    v-if="$vuetify.breakpoint.lgAndUp"
                  ></v-divider>
                  <v-flex xs12 sm12 md5 lg5 pa-1>
                    <v-layout row wrap justify-center pb-2 pl-5>
                      <v-flex xs12 lg5>
                        <b>{{ $t("Profile.corporateaccount") }} :</b>
                      </v-flex>
                      <v-flex xs12 lg7>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              color="#077893"
                              style="cursor: pointer"
                              small
                              @click="Fn_CopyDetail(_SelectAccountId)"
                              v-on="on"
                              >mdi-file-multiple-outline</v-icon
                            >
                          </template>
                          <span>{{ $t("consentlist.copy") }}</span>
                        </v-tooltip>
                        {{ _SelectAccountId }}
                      </v-flex>
                      <v-flex xs12 lg5>
                        <b>{{ $t("Profile.corporatenumber") }} :</b>
                      </v-flex>
                      <v-flex xs12 lg7>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              color="#077893"
                              style="cursor: pointer"
                              small
                              @click="Fn_CopyDetail(_SelectTaxId)"
                              v-on="on"
                              >mdi-file-multiple-outline</v-icon
                            >
                          </template>
                          <span>{{ $t("consentlist.copy") }}</span>
                        </v-tooltip>
                        {{ _SelectTaxId }}
                      </v-flex>
                      <v-flex xs12 lg5>
                        <b>{{ $t("Profile.activationdate") }} : </b>
                      </v-flex>
                      <v-flex xs12 lg7>
                        {{ _SelectUpdatdeAt }}
                      </v-flex>
                      <v-flex xs12 lg5>
                        <b>Token Authorization </b> <br />
                        <b>{{ $t("Profile.forserviceAPIs") }}</b>
                      </v-flex>
                      <v-flex xs12 lg7>
                        <div v-if="_SelectToken.length > 1">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                color="#077893"
                                style="cursor: pointer"
                                small
                                @click="Fn_CopyDetail(_SelectToken)"
                                v-on="on"
                                >mdi-file-multiple-outline</v-icon
                              >
                            </template>
                            <span>{{ $t("consentlist.copy") }}</span>
                          </v-tooltip>
                          {{ _SelectToken.slice(0, 20) }}
                          <!-- <u
                            @click="Fn_GetDataDownloadDoc"
                            class="blue--text mousechange"
                            >{{ $t("petition.DocApi") }}</u
                          > -->
                          <u class="blue--text mousechange" @click="Doc">{{
                            $t("petition.DocApi")
                          }}</u>
                        </div>
                        <div v-else>-</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row wrap>
                  <v-flex xs12 sm12 md7 lg7>
                    <div class="red--text">
                      <b> {{ $t("Profile.NoteLogo") }}</b>
                    </div>
                  </v-flex>
                </v-layout> -->
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogUpload
        :show="DialogUploadLogo"
        @reData="Fn_GetDataLogo"
        @closeDialogUpload="DialogUploadLogo = false"
      />
      <DialogAccountDetail
        :show="DialogAccountDetail"
        @closeDialog="DialogAccountDetail = false"
      />
      <DialogUpdateTel
        :data="Phone"
        :email="Email"
        :show="DialogUpdateTel"
        @reData="Fn_GetDataProfile"
        @closeDialogTel="DialogUpdateTel = false"
      />
      <DialogUpdateEmail
        :phone="Phone"
        :data="Email"
        :show="DialogUpdateEmail"
        @reData="Fn_GetDataProfile"
        @closeDialogEmail="DialogUpdateEmail = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogAccountDetail from "@/components/dialog/DialogProfileAccountDetail.vue";
import DialogUpdateEmail from "@/components/dialog/DialogProfileEmailUpdate.vue";
import DialogUpload from "@/components/dialog/DialogProfileLogoUpload.vue";
import DialogUpdateTel from "@/components/dialog/DialogProfileMobileUpdate.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    DialogUpload,
    DialogUpdateTel,
    DialogUpdateEmail,
    DialogAccountDetail,
  },
  data: function () {
    return {
      valid: true,
      TaxId: "",
      ImageData: [],
      Email: "",
      Phone: "",
      LoadingSync: false,
      DialogAccountDetail: false,
      loadingDownloadData: false,
      DialogUploadLogo: false,
      DialogUpdateTel: false,
      DialogUpdateEmail: false,
      ShowImageNoData: false,
      BtnUploadPic: true,
      BtnUploadPic_Dark: false,
    };
  },
  computed: {
    ...mapGetters(["Profile"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["DataAllRole"]),
    ...mapGetters(["DataAccount"]),

    _Username: {
      get() {
        return this.$cookies.get("OneUsername") || "-";
      },
    },
    _AccountId: {
      get() {
        return this.$cookies.get("OneAccountId") || "-";
      },
    },
    _BusinessNameEng: {
      get() {
        return this.Profile.FirstNameEng + " " + this.Profile.LastNameEng;
      },
    },
    _BusinessNameTH: {
      get() {
        return this.Profile.FirstNameTh + " " + this.Profile.LastNameTh;
      },
    },
    _Email: {
      get() {
        return this.Profile.Email;
      },
    },
    _Phone: {
      get() {
        return this.Profile.Mobile;
      },
    },
    _TiTleName: {
      get() {
        return this.Profile.TitleTh;
      },
    },
    _SelectBusinessNameTH: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    _SelectBusinessNameEng: {
      get() {
        return this.Business.BusinessNameEng || "-";
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
    _SelectAccountId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _SelectToken: {
      get() {
        return this.Business.Token || "-";
      },
    },
    _SelectUpdatdeAt: {
      get() {
        return this.Business.UpdatdeAt || "-";
      },
    },
    _DataAllRole: {
      get() {
        return this.DataAllRole || "-";
      },
    },
    _DataAccount: {
      get() {
        return this.DataAccount || "-";
      },
    },
  },
  watch: {
    _SelectAccountId(val) {
      this.Fn_GetDataLogo();
    },
  },
  methods: {
    async Fn_GetDataLogo() {
      if (this.$cookies.get("BusinessId") != "00000") {
        // this.loadingDownloadData = true
        const payload = {
          BusinessId: this.$cookies.get("BusinessId"),
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "business/GetLogoBusiness",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            if (response.data.Status === "OK") {
              // this.loadingDownloadData = false
              this.ImageData = response.data.Message.ImageBase64;
              this.FileType = response.data.Message.FileType;
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    async Fn_GetDataProfile() {
      const payload = {
        AccessToken: this.$cookies.get("OneAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "token/GetAccountLogin",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {})
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_SyncOneID() {
      this.LoadingSync = true;
      const payload = {
        AccessToken: this.$cookies.get("OneAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "token/SyncOne",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingSync = false;
          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: response.data.Message,
            });
            window.location.reload();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSync = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    Fn_UploadFile() {
      this.DialogUploadLogo = true;
    },
    Fn_EditEmail() {
      this.DialogUpdateEmail = true;
      this.Email = this._Email;
      this.Phone = this._Phone;
    },
    Fn_EditPhone() {
      this.DialogUpdateTel = true;
      this.Phone = this._Phone;
      this.Email = this._Email;
    },
    async Fn_GetDataDownloadDoc() {
      const payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/ResponeFormatCMP",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            const url = response.data.ReportUrl;
            this.Fn_DownloadFileDoc(url);
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_DownloadFileDoc(url) {
      this.axios
        .get(url, {
          withCredentials: false,
          responseType: "blob",
        })
        .then((response) => {
          // โหลดไฟล์
          const blob = new Blob([response.data], {
            type: "application/zip",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "CMPDocumentAPI.docx";
          link.click();
        })
        .catch((error) => {
          Toast.fire({
            icon: "error",
            title: error + "ไม่สามารถดาวน์โหลดไฟล์ได้",
          });
        });
    },
    Fn_checkAdmin() {
      this.DataRole = [];
      var CheckRole = this.$cookies.get("includesRolename");
      if (CheckRole == "false") {
        this.BtnUploadPic = true;
        this.BtnUploadPic_Dark = false;
      } else if (CheckRole == null) {
        // window.location.reload();
      } else {

        this.BtnUploadPic = false;
        this.BtnUploadPic_Dark = true;
      }
      if (this._DataAccount.ArrayCheck.length > 0) {
        this.DialogAccountDetail = false;
      }
    },
    Doc() {
      // this.$router.push("/document-service-index", "_blank");
      window.open("/document-service-index", "_blank");
    },
  },
  mounted() {
    this.Fn_checkAdmin();
    // this.Fn_GetDataLogo()
  },
};
</script>
<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.mousechange:hover {
  cursor: pointer;
}
</style>
